import React from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import clsx from "clsx";

export interface DataTablePaginationProps {
  totalPage: number;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  /** Extra class on the nav wrapper */
  className?: string;
}

const btnClass =
  "inline-flex h-9 w-9 items-center justify-center rounded-md border border-adminTable-border bg-adminTable-header text-adminTable-icon transition-colors";

const DataTablePagination = ({
  totalPage,
  currentPage,
  setCurrentPage,
  className,
}: DataTablePaginationProps) => {
  const canPrev = currentPage > 1;
  const canNext = currentPage < totalPage;

  return (
    <nav
      className={clsx(
        "flex shrink-0 items-center justify-end gap-1 sm:gap-2",
        className
      )}
      aria-label="Table pagination"
    >
      <button
        type="button"
        disabled={!canPrev}
        onClick={() => canPrev && setCurrentPage((p) => p - 1)}
        className={clsx(
          btnClass,
          canPrev
            ? "hover:bg-adminTable-rowHover hover:text-white active:bg-adminTable-canvas"
            : "cursor-not-allowed opacity-40"
        )}
        aria-label="Previous page"
      >
        <MdKeyboardArrowLeft className="text-xl" />
      </button>
      <span className="min-w-[5.5rem] select-none text-center font-sora text-sm font-bold tabular-nums text-white sm:min-w-[6.5rem]">
        {currentPage} / {totalPage}
      </span>
      <button
        type="button"
        disabled={!canNext}
        onClick={() => canNext && setCurrentPage((p) => p + 1)}
        className={clsx(
          btnClass,
          canNext
            ? "hover:bg-adminTable-rowHover hover:text-white active:bg-adminTable-canvas"
            : "cursor-not-allowed opacity-40"
        )}
        aria-label="Next page"
      >
        <MdKeyboardArrowRight className="text-xl" />
      </button>
    </nav>
  );
};

export default DataTablePagination;
